import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Timer } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import ChronoModal from "./ChronoModal";

export default function ChronoButton({ variant = "floating" }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  return (
    <>
      {variant === "tile" ? (
        <button
          data-testid="tile-chrono"
          onClick={() => setOpen(true)}
          className="text-left glass-tile p-6 min-h-[135px] transition-all"
        >
          <Timer className="h-6 w-6 text-white mb-3" strokeWidth={2} />
          <h3 className="font-heading font-black text-3xl uppercase tracking-tight mt-1">{t("chrono.tile_title")}</h3>
        </button>
      ) : variant === "header" ? (
        <button
          data-testid="chrono-header"
          onClick={() => setOpen(true)}
          title={t("chrono.title")}
          className="inline-flex items-center gap-1.5 rounded-md bg-cyan-400 text-black hover:bg-cyan-300 font-bold uppercase tracking-wide text-xs px-3 py-2 transition-colors shrink-0"
        >
          <Timer className="h-4 w-4" />
          <span>{t("chrono.title")}</span>
        </button>
      ) : (
        <button
          data-testid="chrono-fab"
          onClick={() => setOpen(true)}
          title={t("chrono.title")}
          style={{ position: "fixed", right: "16px", bottom: "16px", zIndex: 40 }}
          className="inline-flex items-center gap-2 bg-cyan-400 text-black hover:bg-cyan-300 font-bold uppercase tracking-wide px-4 py-3 rounded-full shadow-lg shadow-black/40"
        >
          <Timer className="h-5 w-5" /> {t("chrono.title")}
        </button>
      )}
      {open && createPortal(<ChronoModal onClose={() => setOpen(false)} />, document.body)}
    </>
  );
}
